import { Injectable } from '@angular/core';
import { AbstractStorage } from './abstract-storage';
import { IBrowserStorage } from './types/browser-storage.interface';
import { StorageType } from './types/storage-type';
import { LocalStorageKeys } from './types/local-storage.enum';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService extends AbstractStorage<StorageType.Local> implements IBrowserStorage<unknown, LocalStorageKeys>  {
    constructor() {
        super(localStorage);
    }
}
